export const normalizeLanguage = (value?: string): string => {
  if (!value) return '';
  return value.trim().toUpperCase();
};

export default normalizeLanguage;
